import type { FormConfig } from "@amzn/aquila-feedback-web-assets";

import { zustandStore } from "./zustand.helpers";

interface ContextData {
    [key: string]: any;
}

export interface ReportIssueActions {
    resetState: () => void;
    resetContextData: () => void;
    setReportIssueContextData: (contextData: ContextData) => void;
    updateReportIssueContextData: (newContextData: ContextData) => void;
    setFormConfig: (configId: string, formConfig: FormConfig) => void;
}

export interface ReportIssueState {
    formConfigMap: {
        [key: string]: FormConfig;
    };
    contextData: ContextData;
}

export const initialState: ReportIssueState = {
    formConfigMap: {},
    contextData: {},
};

export const { store: reportIssueStore } = zustandStore<
    ReportIssueState,
    ReportIssueActions
>("reportIssue", initialState, (set, get) => ({
    setFormConfig: (configId: string, formConfig: FormConfig) => {
        const currentFormConfigMap = get().formConfigMap;
        const updatedFormConfigMap = {
            ...currentFormConfigMap,
            [configId]: formConfig,
        };
        set(() => ({ formConfigMap: updatedFormConfigMap }));
    },
    setReportIssueContextData: (contextData: ContextData) =>
        set(() => ({ contextData })),
    updateReportIssueContextData: (newContextData: ContextData) => {
        const currentContextData = get().contextData;
        set(() => ({
            contextData: { ...currentContextData, ...newContextData },
        }));
    },
    resetContextData: () => set(() => ({ contextData: {} })),
    resetState: () => set(() => ({ ...initialState })),
}));
